<template>
  <!-- 弹窗 -->
  <div class="pop">
    <!-- payloading -->
    <div class="pop-container pay-loading-container">
      <div class="pop-container-title">
        <div class="title-wrap">
          <div class="title-icon"></div>
          <span class="title-text">{{ $t("paygame.orderPay") }}</span>
        </div>
        <div class="pop-close" @click="closeModal"></div>
      </div>
      <!--loading-->
      <div class="pay-loading">
        <img src="../../../imgs/pay-loading.gif" />
        <p class="loading-text">
          {{ $t("paygame.payTip3") }}<br />{{ $t("paygame.payTip4") }}
        </p>
      </div>
      <!-- 文案区域 -->
      <div class="text-container">
        <div class="text-item">
          <span class="t-title">{{ $t("paygame.payWay") }}</span>
          <span class="one-line t-text">{{ data.payment_desc }}</span>
        </div>
        <div class="text-item">
          <span class="t-title">{{ $t("paygame.payAmount") }}</span>
          <span class="one-line t-money"
            ><span class="payAmount">{{ data.product_price }}</span
            ><span class="payCurrency">({{ data.currency }})</span></span
          >
        </div>
      </div>
      <div class="btns">
        <div class="btn btn1" @click="getOrderDetail" ga-data="2705001">
          <span>{{ $t("paygame.paied") }}</span>
        </div>
        <div class="btn btn2" @click="goRePay" ga-data="2705002">
          <span>{{ $t("paygame.payFailed") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    // 关闭弹窗
    closeModal() {
      this.$emit("closeModal");
    },
    // 查询订单详情
    getOrderDetail() {
      this.$emit("getOrderDetail");
    },
    // 重新支付
    goRePay() {
      this.$emit("goRePay");
    },
  },
};
</script>

<style lang="scss">
</style>
